export default "__VITE_ASSET__BcnbsLI2__"